import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import EmpresaReducer from '../empresa/empresaReducer';
import FornecedorReducer from '../fornecedor/fornecedorReducer';
import CentroCustoReducer from '../centroCusto/centroCustoReducer';
import FormaPagamentoReducer from '../formaPagamento/formaPagamentoReducer';
import GrupoReducer from '../grupo/grupoReducer';
import AnaliticaReducer from '../analitica/analiticaReducer';
import DespesaReducer from '../despesa/despesaReducer';
import ReceitaReducer from '../receita/receitaReducer';
import DestinatarioReducer from '../destinatario/destinatarioReducer';
import DreReducer from '../dre/dreReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	usuario: UsuarioReducer,
	empresa: EmpresaReducer,
	fornecedor: FornecedorReducer,
	centroCusto: CentroCustoReducer,
	formaPagamento: FormaPagamentoReducer,
	grupo: GrupoReducer,
	analitica: AnaliticaReducer,
	despesa: DespesaReducer,
	receita: ReceitaReducer,
	destinatario: DestinatarioReducer,
	dre: DreReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

